import { useEffect, useState } from "react";
import { ApiCall } from "../CommonComponents/CustomHooks";
import { Printer } from "lucide-react";
import Barcode from "react-barcode";
import { Check } from "lucide-react";
export default function CNotePrint() {
    const params = new URLSearchParams(window.location.search);
    const AWBNo = params.get("AWBNo");
    const [data, setData] = useState({});

    const getCNotePrintData = async () => {
        const res = await ApiCall('/api/Shipment/CNPrint', {
            TrackingNumber: AWBNo || "",
        });
        if (res.status === "SUCCESS") {
            setData(res?.data);
        }
    };

    useEffect(() => {
        document.title = 'CN Print'
        getCNotePrintData();
    }, []);

    const handlePrint = () => {
        window.print();
    };

    const Checkbox = ({ checked }) => (
        <span style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 14,
            height: 14,
            border: "1px solid #000",
            marginRight: 4
        }}>
            {checked && <Check size={12} strokeWidth={3} />}
        </span>
    );

    return (
        <div>
            {/* ??? Print CSS ???????????????????????????????????????????? */}
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Libre+Barcode+128+Text&display=swap');

                @media print {
                    * {
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }
                    body * { visibility: hidden; }
                    #cnote-print-area,
                    #cnote-print-area * { visibility: visible; }
                    #cnote-print-area {
                        position: fixed;
                        top: 0; left: 0; right: 0;
                        width: 210mm;
                        padding: 8mm;
                        background: white;
                    }
                    .no-print { display: none !important; }
                }

                @page {
                    size: A4 portrait;
                    margin: 0;
                }
            `}</style>

            {/* ??? Print Button ?????????????????????????????????????????? */}
            <div className="no-print" style={styles.controls}>
                <button onClick={handlePrint} style={styles.btnBlue} className="flex gap-2">
                    <Printer /> Print
                </button>
            </div>

            {/* ??? Printable Area ???????????????????????????????????????? */}
            <div id="cnote-print-area" style={styles.page}>
                <table style={styles.slipTable}>
                    <tbody>

                        {/* ?? ROW 1: Logo | Packet Category | Services | Packet Type | Barcode ?? */}
                        <tr>
                            {/* LEFT: Logo */}
                            <td rowSpan={2} style={{ ...styles.td, width: 220 }}>
                                <div style={{ marginBottom: 6 }}>
                                    <img
                                        src="./assets/img/logo.jpg"
                                        style={{ height: 38, objectFit: "contain" }}
                                        alt="logo"
                                    />
                                </div>
                                <div style={{ fontSize: 8, lineHeight: 1.5, borderTop: "0.5px solid #ccc", paddingTop: 4 }}>
                                    <span>{data.companyDetails}</span><br />
                                    <span>{data.website}</span>
                                </div>
                            </td>
                            <td colSpan={3} style={{ ...styles.td, width: 180 }}>
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ fontSize: 10, padding: "1px 2px" }}><b>Mode:</b> {data.mode}</td>
                                            {/*<td style={{ fontSize: 10, padding: "1px 2px" }}><b>Payment:</b> {data.paymentMode}</td>*/}
                                            <td style={{ fontSize: 10, padding: "1px 2px" }}><b>Business Type:</b> {data.businessType}</td>

                                        </tr>
                                        <tr>
                                            <td style={{ fontSize: 10, padding: "1px 2px" }}><b>Service:</b> {data.service}</td>
                                            <td style={{ fontSize: 10, padding: "1px 2px" }}><b>Payment Mode:</b> {data.paymentMode}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontSize: 10, padding: "1px 2px" }}><b>Booking Branch:</b> {data.originName}</td>
                                            <td style={{ fontSize: 10, padding: "1px 2px" }}><b>Destination Branch:</b> {data.destinationName}</td>
                                        </tr>
                                        <tr>
                                            {/*    <td style={{ fontSize: 10, padding: "1px 2px" }}><b>Vendor:</b> {item.vendorName}</td>*/}
                                            <td style={{ fontSize: 10, padding: "1px 2px" }}><b>Forwarding No. / DC No.:</b> {data.forwardingNo}</td>
                                        </tr>
                                        {/*<tr>*/}
                                        {/*    <td style={{ fontSize: 10, padding: "1px 2px" }}><b>PaymentMode:</b> {data.paymentMode}</td>*/}
                                        {/*</tr>*/}
                                    </tbody>
                                </table>
                            </td>

                            {/* RIGHT: BIG BARCODE */}
                            <td rowSpan={2} colSpan={3} style={{ ...styles.td1, textAlign: "center", verticalAlign: "middle", width: 280, padding: "12px 26px" }}>
                                <Barcode
                                    value={data.trackingNumber || ""}
                                    format="CODE128"
                                    width={1.5}
                                    height={50}
                                    displayValue={true}
                                    fontSize={12}
                                    margin={2}
                                />
                            </td>

                        </tr>

                        {/* ?? ROW 3: Booking Date | Booking Type ?? */}
                        <tr>
                            <td colSpan={3} style={styles.td}>
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ fontSize: 10, padding: "1px 2px" }}><b>Booking Date:</b> {data.bookingDate}</td>
                                            <td style={{ fontSize: 10, padding: "1px 2px" }}><b>Booking Type:</b> {data.bookingType}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan='2' style={{ fontSize: 10, padding: "1px 2px" }}><b>Client:</b> {data.clientName}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>

                        {/*  CONSIGNOR / CONSIGNEE SEPARATE BLOCK */}
                        {/*<tr style={{ visibility: "hidden" }} >*/}
                        {/*    <td colSpan={8} style={{ height: 6, border: "none" }}></td>*/}
                        {/*</tr>*/}

                        <tr>
                            <td colSpan={2} style={styles.secTitle}>Consignor Details</td>
                            <td colSpan={5} style={styles.secTitle}>Consignee Details</td>
                        </tr>
                        <tr>
                            {/* CONSIGNOR */}
                            <td colSpan={2} style={{ ...styles.partyBox, paddingLeft: "10px" }}>
                                <div style={styles.boldLine}>
                                    {data.consignorName}
                                </div>

                                <div style={styles.addressLine}>
                                    {[
                                        data.consignorAddress,
                                        data.consignorCity,
                                        data.consignorState,
                                        data.consignorPinCode
                                    ].filter(Boolean).join(", ")}
                                </div>

                                <div style={styles.smallLine}><b></b> {data.pickupPoint}</div>
                                <div style={styles.smallLine}><b></b> {data.referenceNo}</div>
                                <div style={styles.smallLine}><b></b> {data.consignorPhone}</div>
                            </td>

                            {/* CONSIGNEE */}
                            <td colSpan={4} style={{ ...styles.partyBox, paddingLeft: "10px" }}>
                                <div style={styles.boldLine}>
                                    {data.consigneeName}
                                </div>

                                <div style={styles.addressLine}>
                                    {[
                                        data.consigneeAddress,
                                        data.consigneeCity,
                                        data.consigneeState,
                                        data.consigneeCountry,
                                        data.consigneePinCode
                                    ].filter(Boolean).join(", ")}
                                </div>

                                <div style={styles.smallLine}>
                                    {data.consigneeCompany}
                                </div>
                                <div style={styles.smallLine}>
                                    {data.consigneePhone}
                                </div>
                            </td>
                        </tr>


                        {/* Shipment Column Headers */}
                        <tr colSpan={8} style={styles.secTitle}>
                            <td style={styles.td}>Invoice No.</td>
                            <td style={styles.td}>Invoice Date</td>
                            <td style={styles.td}>Invoice Value</td>
                            <td style={{ ...styles.td, textAlign: "center", fontWeight: "bold" }}>No. of Pcs</td>
                            <td style={{ ...styles.td, textAlign: "center", fontWeight: "bold" }}>Actual Weight</td>
                            <td colSpan={2} style={{ ...styles.td, textAlign: "center", fontWeight: "bold" }}>Charged Weight</td>
                        </tr>

                        {/* Shipment Values */}
                        <tr>
                            <td style={styles.td}>{data.invoiceNo}</td>
                            <td style={styles.td}>{data.invoiceDate}</td>
                            <td style={styles.td}>{data.invoiceValue}</td>
                            <td style={{ ...styles.td, textAlign: "center", fontSize: 17, fontWeight: "bold" }}>{data.pieces}</td>
                            <td style={{ ...styles.td, textAlign: "center", fontSize: 15, fontWeight: "bold" }}>{data.actualWeight}</td>
                            <td colSpan={2} style={{ ...styles.td, textAlign: "center", fontSize: 15, fontWeight: "bold" }}>{data.chargeableWeight}</td>
                        </tr>

                        {/* ?? Shipper Auth ?? */}
                        <tr>
                            <td colSpan={4} style={styles.secTitle}>CONSIGNOR'S SIGNATURE &amp; AUTHORIZATION</td>
                            <td style={styles.td}>LR Amount &nbsp; {data.cashAmount}</td>
                            <td colSpan={2} style={styles.td}> {data.collectableAmount}</td>
                        </tr>
                        <tr>
                            <td colSpan={4} rowSpan={4} style={{ ...styles.td, fontSize: 9, lineHeight: 1.6 }}>
                                I/we certify and warrant that all details given here in are correct and true. I/we accept the
                                terms and condition of carriage. I/we hereby authorize Patliputra Logistics for shipping and custom
                                clearance of this package at Kolkata. The Warsaw convention may also apply.
                                I/we understand Patliputra Logistics that does not transport cash or dangerous goods.
                            </td>
                            <td colSpan={3} style={styles.td}>Content/Description : {data.contentDescription}</td>
                        </tr>
                        <tr>
                            <td colSpan={3} style={styles.td}>Remarks : {data.remarks}</td>
                        </tr>
                        <tr>
                            {/*<td colSpan={3} style={{ ...styles.td, height: 28 }}></td>*/}
                        </tr>
                        <tr>
                            <td colSpan={3} style={{ ...styles.td, fontSize: 9 }}>
                                Received shipment in good order and condition
                            </td>
                        </tr>

                        {/* ?? Signatures ?? */}
                        <tr>
                            <td colSpan={2} style={{ ...styles.td, height: 40 }}>Consignor's Signature</td>
                            <td colSpan={2} style={styles.td}>Consignee's Signature</td>
                            <td colSpan={2} style={styles.td}>Date</td>
                        </tr>

                        {/* Footer */}
                        {/*<tr>*/}
                        {/*    <td colSpan={7} style={{ ...styles.td, fontSize: 9.5 }} className="text-center">*/}
                        {/*        {data.printDate}*/}
                        {/*    </td>*/}
                        {/*</tr>*/}

                    </tbody>
                </table>
            </div>
        </div>
    );
}

// ??? Styles ???????????????????????????????????????????????????????????????
const styles = {
    controls: {
        display: "flex",
        gap: 10,
        padding: "12px 16px",
        background: "#f5f5f5",
        borderBottom: "1px solid #ddd",
        alignItems: "center",
    },
    btnBlue: {
        padding: "9px 22px",
        background: "#2c6a9b",
        color: "white",
        border: "none",
        borderRadius: 6,
        cursor: "pointer",
        fontSize: 14,
        fontWeight: 600,
    },
    page: {
        width: 794,
        minHeight: 1123,
        background: "white",
        margin: "0px auto",
        padding: "20px 0px",
        color: "#000",
        fontSize: 12,
        fontFamily: "Arial, sans-serif",
        boxSizing: "border-box",
    },
    slipTable: {
        borderCollapse: "collapse",
        width: "100%",
        border: "1.5px solid #222",
    },
    td1: {
        border: "0.5px solid #888",
        padding: "3px 6px",
        verticalAlign: "center",
        fontSize: 10,
    },
    td: {
        border: "0.5px solid #888",
        padding: "3px 6px",
        verticalAlign: "top",
        fontSize: 10,
    },
    secTitle: {
        border: "0.5px solid #888",
        padding: "3px 6px",
        background: "#e8e8e8",
        fontWeight: "bold",
        fontSize: 11,
    },
    label: {
        fontWeight: "bold",
        fontSize: 10,
        marginBottom: 2,
    },
    barcodeFont: {
        fontFamily: "'Libre Barcode 128 Text', monospace",
        fontSize: 52,
        lineHeight: 1,
        letterSpacing: 2,
        color: "#000",
        textAlign: "center",
    },
    barcodeNum: {
        fontSize: 10,
        letterSpacing: 3,
        fontWeight: 600,
        marginTop: 2,
        textAlign: "center",
    },
    boldLine: {
        fontWeight: "bold",
        fontSize: 11,
        marginBottom: 3
    },

    addressLine: {
        fontSize: 10,
        marginBottom: 5,
        lineHeight: 1.4,
    },

    smallLine: {
        fontSize: 10,
        marginBottom: 2
    },
};